import { Texture } from "three";
import { DumplingAOTexture } from "./textures/DumplingAOTexture";
var TexturesManager = /** @class */ (function () {
    // ----------------------------------------------------------------------------------------------------
    // Construct / Destroy
    //
    function TexturesManager(params) {
        var _this = this;
        this.textures = {};
        var keys = Object.keys(params.images);
        keys.forEach(function (key) {
            var texture = new Texture(params.images[key]);
            // texture.minFilter = LinearFilter;
            // texture.magFilter = LinearFilter;
            texture.needsUpdate = true;
            _this.textures[key] = texture;
        });
        var dumplingAOTexture = new DumplingAOTexture();
        dumplingAOTexture.textures.forEach(function (texture, index) {
            _this.textures['dumpling_ao' + (index + 1)] = texture;
        });
    }
    TexturesManager.prototype.destroy = function () {
    };
    return TexturesManager;
}());
export { TexturesManager };
